import { InvoiceStatus as ProtoInvoiceStatus } from "@alch/protobufs-es/billing/billing_core_pb";
import z from "zod";
const BillingAddress = z.object({
  line1: z.string().nonempty(),
  line2: z.string(),
  city: z.string().nonempty(),
  state: z.string(),
  postalCode: z.string().nonempty(),
  country: z.string().nonempty()
});
const TaxId = z.object({
  country: z.string(),
  type: z.string(),
  value: z.string()
});
const InvoiceStatus = z.nativeEnum({
  ISSUED: ProtoInvoiceStatus.ISSUED,
  PAID: ProtoInvoiceStatus.PAID,
  PAYMENT_FAILED: ProtoInvoiceStatus.PAYMENT_FAILED
});
export {
  BillingAddress,
  InvoiceStatus,
  TaxId
};
//# sourceMappingURL=billing.js.map